import { useCallback } from 'react';
import { useRouter } from 'next/router';

import { deleteParamFromQueryByName } from '@keaze/web/utils/deleteParamFromQueryByName';
import {
  ExpectedSearchParamsForListing,
  SearchBasicParams,
  SearchPartnerParams,
} from '@keaze/web/common/interfaces';
import {
  getSearchBasicParams,
  getPartnersParams,
  getSearchParamsForListing,
} from '@keaze/web/utils/params';
import { UpdateParam } from './useSearchQueryParams.types';

type CustomUseSearchQueryParamsExpected = {
  partnerParams: SearchPartnerParams;
  paramsForListing: ExpectedSearchParamsForListing;
  updateParam: UpdateParam;
};

type UseSearchQueryParamsExpected = CustomUseSearchQueryParamsExpected &
  SearchBasicParams;

type UseSearchQueryParams = () => UseSearchQueryParamsExpected;

export const useSearchQueryParams: UseSearchQueryParams = () => {
  const router = useRouter();
  const basicParams = getSearchBasicParams(router.query);
  const partnerParams = getPartnersParams(router.query);
  const paramsForListing = getSearchParamsForListing(router.query);

  const updateParam: UpdateParam = useCallback(
    ({ param, value, router: currentRouter }) => {
      const isEmpty = value === '' || value === null;

      if (isEmpty) {
        return deleteParamFromQueryByName({
          name: param,
          router: currentRouter,
          withShallow: true,
        });
      }

      return router.replace(
        { query: { ...currentRouter.query, [param]: value } },
        undefined,
        { shallow: true }
      );
    },
    [router]
  );

  return {
    ...basicParams,
    partnerParams,
    paramsForListing,
    updateParam,
  };
};
